import React, { useState, useEffect, useRef } from 'react';
import { ArrowDownRight } from 'lucide-react';

const CustomSelect = ({ value, options, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectedLabel = options.find((o) => o.id === value)?.label || value;

    return (
        <div className="relative" ref={containerRef}>
            <button
                type="button"
                onMouseDown={(e) => { e.preventDefault(); setIsOpen(!isOpen); }} // use onMouseDown to prevent focus issues
                className={`flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 transition-all hover:border-gray-300 hover:bg-gray-50 ${isOpen ? 'border-[#2563EB] ring-2 ring-[#2563EB]/10' : ''}`}
            >
                <span>{selectedLabel}</span>
                <ArrowDownRight
                    className={`h-4 w-4 text-gray-400 transition-transform duration-200 ${isOpen ? '-rotate-90' : ''}`}
                />
            </button>

            {isOpen && (
                <div className="animate-in fade-in zoom-in-95 duration-100 absolute right-0 top-full z-50 mt-2 w-48 origin-top-right overflow-hidden rounded-xl border border-gray-100 bg-white p-1 shadow-xl ring-1 ring-black/5">
                    {options.map((opt) => (
                        <button
                            key={opt.id}
                            onClick={() => {
                                onChange(opt.id);
                                setIsOpen(false);
                            }}
                            className={`flex w-full items-center justify-between rounded-lg px-3 py-2 text-sm transition-colors ${value === opt.id
                                ? 'bg-[#2563EB]/5 font-bold text-[#2563EB]'
                                : 'text-gray-600 hover:bg-gray-50'
                                }`}
                        >
                            {opt.label}
                            {value === opt.id && <div className="h-1.5 w-1.5 rounded-full bg-[#2563EB]" />}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;
